<div class="imprint-container">
    <div class="imprint-content">
      <h1 i18n="@@privacyHeaderTitle">Information/data protection information (pursuant to Art. 13 GDPR)</h1>
      <h2 i18n="@@privacyHeaderSubtitle">OER Conversion Tool – convOERter</h2>
      <h3 i18n="@@controllerTitle">1. Name and address of the person responsible</h3>
      <p i18n="@@controllerInfo">
        The controller within the meaning of the General Data Protection Regulation and other national
        data protection laws of the member states as well as other data protection regulations is the: <br>
        Rector of RWTH Aachen University<br>
        Templergraben 55<br>
        52062 Aachen (home address)<br>
        52056 Aachen (postal address)<br>
        Telephone: +49 241 80 1<br>
        Fax: +49 241 80 92312<br>
        E-Mail: <a href="mailto:rektorat@rwth-aachen.de">rektorat@rwth-aachen.de</a><br>
        Website: <a href="https://www.rwth-aachen.de/rektorat" target="_blank">www.rwth-aachen.de/rektorat</a><br><br>
        For implementation of the data analysis for convOERter-tool:<br>
        RWTH Aachen University <br>The Learning Technologies Research Group - Computer Science 9<br>
        Prof. Dr. Ulrik Schroeder<br>
        Ahornstr. 55, 52074 Aachen<br>
        Phone: +49 241 80-21931
      </p>
  
      <h3 i18n="@@dpOfficerTitle">2. Contact details of the Data Protection Officer</h3>
      <p i18n="@@dpOfficerInfo">
        Availability of the officially appointed data protection officer: <br>
        Data Protection Office of RWTH Aachen University<br>
        Templergraben 83<br>
        52062 Aachen (home address)<br>
        52056 Aachen (postal address)<br>
        Aachen, Germany<br>
        Telephone: +49 241 80 94114<br>
        E-Mail: <a href="mailto:dsb@rwth-aachen.de">dsb@rwth-aachen.de</a>
      </p>
  
      <h3 i18n="@@generalProcessingTitle">3. General information on data processing</h3>
  
      <h4 i18n="@@processingPurposeTitle">a) Subject matter and purpose of the processing of personal data</h4>
      <p i18n="@@processingPurposeInfo">
        The convOERter is a web-based tool for the semi-automatic conversion of teaching material into OER,
        based on the replacement of non-OER images with OER images.<br>
        The convOERter processes usage data, including file import frequency and user feedback, to
        improve functionality and user experience if you have consented to the processing of this data.
        Consent is given on a voluntary basis, the use of convOERter is also possible without consent.
      </p>
  
      <p i18n="@@dataCollectedIntro">Specifically, the following data is collected when the website is accessed:</p>
      <ul>
        <li i18n="@@dataSessionId">A session ID, also randomly generated, which is reset each time the application is reloaded</li>
        <li i18n="@@dataTimezone">The browser's time zone to derive the country reference.</li>
      </ul>
  
      <p i18n="@@dataEventsIntro">There are also logs of research-relevant events:</p>
      <ul>
        <li i18n="@@eventUpload">Uploading a file with non-OER content</li>
        <li i18n="@@eventLicense">Selecting a target license</li>
        <li i18n="@@eventSearch">Using the online search to replace with a relevant OER image</li>
        <li i18n="@@eventImageSelect">Selecting a suitable OER image from the search results</li>
        <li i18n="@@eventConvert">Converting the image with the target license</li>
        <li i18n="@@eventSave">Clicking the “Save file” button to download the new OER document</li>
        <li i18n="@@eventFeedback">Providing feedback on tool usage (Optional)</li>
      </ul>
      <p i18n="@@dataClarification">
        Only the occurrence of the event with time and session ID is logged. The content, such as an uploaded file, is not processed or saved.
      </p>
  
      <p i18n="@@analysisIntro">The following analyses are carried out with this data:</p>
      <ul>
        <li i18n="@@analysisDateTime">Date and time of access</li>
        <li i18n="@@analysisImportFrequency">Frequency of file import</li>
        <li i18n="@@analysisFileTypeFrequency">Frequency of file types</li>
        <li i18n="@@analysisAverageImportTime">Average file import time</li>
        <li i18n="@@analysisBounceRates">Bounce rates</li>
        <li i18n="@@analysisBounceStartClick">Bounce rate at start click</li>
        <li i18n="@@analysisBounceLoadedTool">Bounce rate for the loaded tool</li>
        <li i18n="@@analysisBounceListedImage">Bounce rate of the listed image</li>
        <li i18n="@@analysisSessionFrequency">Session frequency</li>
        <li i18n="@@analysisImageProcessingFrequency">Frequency of image processing</li>
        <li i18n="@@analysisAverageTaskTime">Average time required for tasks (file import, external replacement, external search, feedback transmission)</li>
        <li i18n="@@analysisFeedbackFrequency">Feedback frequency</li>
      </ul>

      <p i18n="@@sessionNote">
        The session frequency does not refer to individual users, but to the application itself. It serves as a measure of utilization and is determined by the number of session starts.
      </p>
  
      <h4 i18n="@@recipientsTitle">b) Recipients of the data</h4>
      <p i18n="@@recipientsInfo">
        The convOERter does not include the collection or publication of images found in the uploaded document. The data collected on the basis of consent (e.g. usage statistics and feedback) are used exclusively for internal analysis and tool improvement purposes. No external recipients or third parties are involved in the processing or have access to this data.
      </p>
  
      <h4 i18n="@@legalBasisTitle">c) Legal basis for the processing of personal data</h4>
      <p i18n="@@legalBasisInfo">
        The processing of data in connection with the use of the convOERter is carried out as part of the university's public relations work, which is one of the university's tasks. The legal basis for this is Art. 6 para. 1 sentence 1 lit. e), para. 3 GDPR i.V.m. § 3 para. 1 DSG NRW in conjunction with. §§ 3 para. 1, 8 para. 6 HG NRW. <br>
The processing of usage data and user feedback is based on consent in accordance with. Art. 6 para. 1 sentence 1 lit. a) GDPR, which also serves as the legal basis.
      </p>
  
      <h4 i18n="@@erasureTitle">d) Data erasure and storage duration</h4>
      <p i18n="@@erasureInfo">
        The stored usage data is deleted at irregular intervals each time convOERter is redeployed or when the purpose no longer applies. Log data is not stored permanently. When using convOERter, only technical and system-related data required for the operation of the service is processed. This data does not contain any personal or sensitive information. Data may be stored if this is required by statutory retention obligations.
      </p>
  
      <h3 i18n="@@logFilesTitle">4. Provision of the website and creation of log files</h3>
  
      <h4 i18n="@@logPurposeTitle">a) Subject matter and purpose of the processing of personal data</h4>
      <p i18n="@@logPurposeInfo">
        Each time this website is accessed, an exchange of information between your end device, for
example your computer, tablet or cell phone, and servers that make the website available for
retrieval is technically necessary in order to establish communication between your end device
and this website. Each time the website is accessed, data about this process is also temporarily
processed and stored in a log file. <br>
When you access the website, certain information is exchanged between your end device and the
web server for technical reasons. Personal access data such as IP addresses are not stored or
processed. <br>
The data is processed for the proper operation of the websites, i.e. to detect, limit or eliminate
malfunctions or errors. <br>
In addition, the log data is processed for technical security purposes, in particular to protect
against and defend against cyber attacks. This is done on the basis of Art. 6 para. 1 sentence 1 lit.
e), 32 para. 1 GDPR i.V.m. § 58 para. 1 DSG NRW.
      </p>
  
      <h4 i18n="@@logLegalBasisTitle">b) Legal basis for the processing of personal data</h4>
      <p i18n="@@logLegalBasisInfo">
        The temporary storage of data for technical communication and log files is carried out on the basis
of Art. 6 para. 1 sentence 1 lit. e), para. 3 GDPR in conjunction with. § 3 para. 1 DSG NRW in
conjunction with. §3 HG NRW.
      </p>
  
      <h4 i18n="@@logStorageTitle">c) Data erasure and storage duration</h4>
      <p i18n="@@logStorageInfo">
        There is no permanent storage of log files. Temporarily generated log files are used exclusively for
technical error analysis as part of system maintenance and necessary bug fixes. Regular rotation
or archiving of the log files is not planned. There is no permanent storage; temporary log data is
only stored for as long as is necessary to ensure operation and to analyse errors.
      </p>
  
      <h3 i18n="@@rightsTitle">5. Rights of the data subject</h3>
      <p i18n="@@rightsInfo">
        If personal data is processed by the data subject, he/she has the following rights vis-à-vis the
controller. <br>
Pursuant to Article 15 et seq. GDPR, the data subject has the right of access to the personal data
concerned, the right to rectification or erasure or restriction of processing, the right to object
to processing and the right to data portability. Pursuant to Article 77 GDPR, he/she also has the
right to lodge a complaint with the competent data protection supervisory authority <br>
        <a href="https://www.ldi.nrw.de/kontakt" target="_blank">(https://www.ldi.nrw.de/kontakt)</a> if the data subject considers that the processing of personal data
        concerning him/her infringes this regulation. If the processing is based on the consent of the data
        subject (see Art. 6 para. 1 sentence 1 lit. a), Art. 9 para. 2 lit. a) GDPR), he/she also has the right
        to withdraw consent at any time without affecting the lawfulness of processing based on consent
        before its withdrawal; this only takes effect for the future. <br>
        To exercise the aforementioned rights, the data subject should send an e-mail to <br> <a href="mailto:lufgi9@informatik.rwth-aachen.de">lufgi9@informatik.rwth-aachen.de</a>
      </p>
    </div>
  </div>
  